import { Button } from 'antd';
import { SpText } from 'components/DesignKit';
import React, { useState } from 'react';

type Props = {
    text: String
}

const TextWithToggle = ({ text }: Props) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const maxLength = 70;

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const safeText = typeof text === 'string' ? text : '';

  const displayedText = isExpanded || safeText.length <= maxLength
    ? safeText
    : `${safeText.slice(0, maxLength)}...`;

  return (
    <div>
      <SpText fontWeight="400" fontSize="12px" color="#000000">
        {displayedText}
      </SpText>
      {safeText?.length > maxLength && (
        <Button
          onClick={handleToggle}
          type="link"
          style={{
            fontSize: '12px',
            padding: '0px',
          }}
        >
          {isExpanded ? 'Show less' : 'Show more'}
        </Button>
      )}
    </div>
  );
};

export default TextWithToggle;
